<template>
	<div>
		<el-drawer
      ref="drawerRef"
			:model-value='options.show ?? false'
			:title="options.title ?? '标题'"
			:show-close='false'
			@close='handleClose'
			:before-close="handleBeforeClose"
			:size="options.width ?? '80%'"
			:class="options.className ?? ''"
			:header-class="options.headerClass ?? ''"
			:body-class="options.bodyClass ?? ''"
			append-to-body
			:close-on-click-modal='false'
		>
			<template #header>
        <slot name="header" :close="requestClose">
				<div class='flex justify-between cu-drawer-header'>
					<div class='flex align-center cu-drawer-header__left'>
						<i class='iconfont icon-guanbi1 close-button cursor cu-drawer-header__close' @click='requestClose'
						   style='font-size: 20px'></i>
						<span class='text-13 margin-left-10 text-black-3 cu-drawer-header__title'>{{ options.title ?? '' }}</span>
					</div>
					<div class='flex margin-left-10 align-center cu-drawer-header__actions'>
            <cu-button type="save" v-if="options.button ?? true" @click="handleConfirm"></cu-button>
            <cu-button class="margin-left-10" type="cancel" v-if="options.button ?? true" @click="requestClose"></cu-button>
					</div>
				</div>
        </slot>
			</template>
			<div class="auto-page">
				<slot></slot>
			</div>
		</el-drawer>
	</div>
</template>

<script setup>
import { ref } from "vue";
import CuButton from "@/components/button/CuButton";

const props = defineProps({
  options: {
    type: Object,
    default: () => {
      return {
        show: false,
        cancelText: '取消',
        confirmText: '确定',
        loading: false,
        button:true,
      };
    }
  },
})

const emit = defineEmits(['close','confirm']);
const drawerRef = ref(null);

const handleClose = () => {
  emit('close');
}

// 同时保护标题关闭、取消和 Esc，未配置守卫的抽屉保持原行为。
const canClose = async () => typeof props.options.beforeClose !== 'function' || await props.options.beforeClose();
const handleBeforeClose = async (done) => {
  if (await canClose()) done();
};
const requestClose = () => drawerRef.value?.handleClose();

const handleConfirm = () => {
  emit('confirm')
}
</script>

<style>
.close-button:hover {
	color: #0081ff;
}

/* 确保 drawer body 区域有正确的高度 */
:deep(.el-drawer__body) {
	height: calc(100% - 60px);
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	padding-bottom: 10px;
}

:deep(.auto-page) {
	height: 100%;
}
</style>
